import { useEffect, useState } from 'react';
import { Badge, Button, ButtonGroup, Modal, Table } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import { TbTrash, TbTrashOff } from 'react-icons/tb';
import { deleteUsers, getTransactions, getUserAccountDetail, getUsers, getUserWithdrawableTransactions } from '../../../Services/AdminServices/adminUserServices';
import UserAccountDetail from './UserAccountDetail';
import UserTransaction from './UserTransaction';
import UserWithdrawableTransaction from './UserWithdrawableTransaction';
import DataTables from '../../Main/DataTable/DataTables';

const Users = () => {

    const [tab, setTab] = useState("transaction")
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([])
    const [userTransaction, setUserTransaction] = useState([])
    const [withdrawableTransaction, setwithdrawableTransaction] = useState([])
    const [lgShow, setLgShow] = useState(false);
    const [accountDetail, setAccountDetail] = useState(null);


    const columns = [
        {
            name: 'S.No.',
            selector: (row, index) => index + 1,
            width: '80px', // optional: adjust column width
        },
        { name: 'Name', selector: row => row.name },
        { name: 'Email', selector: row => row.email },
        { name: 'Referral Code', selector: row => row.referral_code },
        { name: 'Wallet Balance', selector: row => row.wallet_balance },
        {
            name: 'Status',
            cell: row => <Badge bg="success">{row?.status}</Badge>,
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <FaEye size={16} onClick={() => handleShow(row?.id)} style={{ cursor: "pointer" }} />
                    {row?.role !== "admin" ? (
                        <TbTrash className='ms-3' onClick={() => handleDelete(row?.id)} style={{ cursor: "pointer" }} size={16} />
                    ) : (
                        <TbTrashOff className='ms-3' style={{ cursor: "not-allowed" }} size={16} />
                    )}
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    const getAllUsers = async (e) => {
        setIsLoading(true);
        let response = await getUsers();

        if (response.code === 200) {
            setIsLoading(false);
            setData(response?.result?.users?.original?.data)
        } else if (response.code === 401) {
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    };

    const getUserTransactions = async (id) => {
        setIsLoading(true);
        let response = await getTransactions(id);
        setUserTransaction(response?.result?.transactions?.data)
        if (response.code === 200) {
            setIsLoading(false);
        } else if (response.code === 401) {
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    };

    const getWithdrawableTransactions = async (id) => {
        setIsLoading(true);
        let response = await getUserWithdrawableTransactions(id);
        if (response.code === 200) {
            setIsLoading(false);
            setwithdrawableTransaction(response?.result?.data?.original?.data)
        } else if (response.code === 401) {
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    };


    const getUserAccount = async (id) => {
        setIsLoading(true);
        let response = await getUserAccountDetail(id);
        setAccountDetail(response?.result?.accountDetail)
        if (response.code === 200) {
            setIsLoading(false);
        } else if (response.code === 401) {
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        setIsLoading(true);
        let response = await deleteUsers(id);

        if (response.code === 200) {
            setIsLoading(false);
            getAllUsers()

        } else if (response.code === 401) {
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    }

    const handleShow = (id) => {
        setLgShow(true)
        getUserTransactions(id)
        getUserAccount(id)
        getWithdrawableTransactions(id)
    }



    useEffect(() => { getAllUsers() }, [])

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>User Management</h3>
                        <p className='text-muted'>View and manage all registered users</p>
                    </div>


                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (

                        <DataTables filter={true} columns={columns} data={data} />
                    )}
                </div>
            </div>

            <Modal
                size="lg"
                show={lgShow}
                onHide={() => setLgShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Account Detail
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-lg-12 mt-4">
                        <div className='p-1 bg-light shadow-sm rounded'>
                            <ButtonGroup className='w-100' aria-label="Basic example">
                                <Button onClick={() => setTab("transaction")} variant={tab === "transaction" ? "primary" : ""}>Transaction</Button>
                                <Button onClick={() => setTab("withdrawableTransaction")} variant={tab === "withdrawableTransaction" ? "primary" : ""}>Withdrawal Requests</Button>
                            </ButtonGroup>
                        </div>
                    </div>

                    <div className="col-lg-12 mt-3">
                        {
                            tab === "transaction" && (
                                <UserTransaction userTransaction={userTransaction} />
                            )
                        }

                        {
                            tab === "withdrawableTransaction" && (
                                <UserWithdrawableTransaction withdrawableTransaction={withdrawableTransaction} />
                            )
                        }
                    </div>
                </Modal.Body>
            </Modal>

        </>



    )
}

export default Users